import {Heading} from "../../../components";
import WhyUsTabs from "../../../components/WhyUsTabs";
import React, {Suspense} from "react";
import {useTranslation} from "react-i18next";

export default function  WhyUs() {

    const {t} = useTranslation();

    const WhyUsGrid = [
        {
            className: "",
            text: "text-[#191C30E5]",
            icon: "/images/why_us_1.svg",
            title: t("why_us.title.1"),
            description: t("why_us.description.1sm"),
            bg: "bg-[#EDEDED]"
        },
        {
            className: "",
            text: "text-[#FFFFFF]",
            icon: "/images/why_us_2.svg",
            title: t("why_us.title.2"),
            description: t("why_us.description.2"),
            bg: "bg-[#6C6C6C]"
        },
        {
            className: "",
            text: "text-[#FFFFFF]",
            icon: "/images/why_us_3.svg",
            title: t("why_us.title.3"),
            description: t("why_us.description.3"),
            bg: "bg-[#FF573A]"
        },
        {
            className: "",
            text: "text-[#FFFFFF]",
            icon: "/images/why_us_4.svg",
            title: t("why_us.title.4"),
            description: t("why_us.description.4"),
            bg: "bg-[#0C88F0]"
        },
    ];

    return (
        <>
            <section id="WhyUs">
                <div className="flex flex-col items-center px-6 sm:px-[16px]">
                    <div className="container-xs flex flex-col items-start gap-10">
                        <Heading
                            size="desktop_heading_4"
                            as="h2"
                            className="font-medium text-[#191c2fe5] leading-[33.6px] gap-4 uppercase">
                            {t("why_us.head_title")}
                        </Heading>
                        <div className="grid lg:grid-cols-2 grid-cols-1 gap-5 md:gap-4 self-stretch">
                            <Suspense fallback={<div>Loading </div>}>
                                {WhyUsGrid.map((d, index) => (
                                    <WhyUsTabs {...d} key={"grid" + index}/>
                                ))}
                            </Suspense>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}